// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1johc","inputWrap":"styles_inputWrap__3W3G2","input":"styles_input__27Bfw"};